var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"81aeb39b86ddb22381ce27e0a37bcb1b3304d380"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ray@webshop-farm"]={id:"81aeb39b86ddb22381ce27e0a37bcb1b3304d380"};
      